import { Component, input, signal, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlarmsClassificationFormComponent } from '../alarms-classification-form/alarms-classification-form.component';
import { MapComponent } from '/app/components/map/map.component';
import { Alarm, AlarmsResponse } from '../../models/alarm.model';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlarmsService } from '../../services/alarms.service';
import { HelpService } from '/app/services/help/help.service';



@Component({
  selector: 'app-alarms-details',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    DatePipe,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    AlarmsClassificationFormComponent,
    MapComponent,
    MatTableModule,
    MatDividerModule,
    MatListModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './alarms-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './alarms-details.component.scss',
})
export class AlarmsDetailsComponent {
  selectedAlarm = input<any>(null);
  @Output() closed = new EventEmitter<void>();
  alarmsFromChild = input<Alarm[]>([]);
  monitorId = input<string | null>(null);

  alarms = signal<Alarm[]>([]);
  filteredAlarms = signal<Alarm[]>([]);
  selectedAlarms: Set<string> = new Set();
  displayedColumns: string[] = ['id', 'direccion', 'timestamp'];
  detallesAlarm: boolean = false;

  // Filtros
  holders: string[] = [];
  events: string[] = [];
  selectedHolder: string = '';
  selectedEvent: string = '';
  searchTerm: string = '';

  // Paginación
  currentPage: number = 0;
  pageSize: number = 10;
  isLoadingMore = signal(false);
  hasMorePages = signal(true);

  // Formulario de clasificación
  classificationForm: FormGroup;

  statusOptions = [
    { value: 'Alarma Atrasada', label: 'Alarma Atrasada' },
    { value: 'Alarma Clasificación Automática', label: 'Alarma Clasificación Automática' },
    { value: 'Alarma Verdadero', label: 'Alarma Verdadero' },
    { value: 'Alarma en Falso', label: 'Alarma en Falso' },
    { value: 'Alarmas Pendientes de Trato', label: 'Alarmas Pendientes de Trato' },
    { value: 'Cliente Inactivo', label: 'Cliente Inactivo' },
    { value: 'Cliente a Desinstalar', label: 'Cliente a Desinstalar' },
    { value: 'Cliente en Stand By', label: 'Cliente en Stand By' },
    { value: 'Conductor Fumando', label: 'Conductor Fumando' },
    { value: 'Detección de Cansancio', label: 'Detección de Cansancio' },
    { value: 'Detección de Distracción', label: 'Detección de Distracción' },
    { value: 'Detección de Fatiga', label: 'Detección de Fatiga' },
    { value: 'Detección de Uso de Teléfono', label: 'Detección de Uso de Teléfono' },
    { value: 'En Duda', label: 'En Duda' },
    { value: 'Error de Manipulación', label: 'Error de Manipulación' },
    { value: 'Falsa Alarma con Activación Policial', label: 'Falsa Alarma con Activación Policial' },
    { value: 'Móvil Inactivo', label: 'Móvil Inactivo' },
    { value: 'Móvil Observado', label: 'Móvil Observado' },
    { value: 'Móvil a Desinstalar', label: 'Móvil a Desinstalar' },
    { value: 'Móvil en Base Cliente', label: 'Móvil en Base Cliente' },
    { value: 'Móvil en Centro', label: 'Móvil en Centro' },
    { value: 'Notificado a Contacto', label: 'Notificado a Contacto' },
    { value: 'Otro', label: 'Otro' },
    { value: 'Probable Falla', label: 'Probable Falla' },
    { value: 'Prueba Atención Servicios', label: 'Prueba Atención Servicios' },
    { value: 'Prueba de Servicios', label: 'Prueba de Servicios' },
    { value: 'Sin Contacto', label: 'Sin Contacto' }
  ];



  successMessage = signal('');
  errorMessage = signal('');

  isClassificationEnabled = signal(false);
  expandedSections: { [key: string]: boolean } = {
    basic: true,
    dates: false,
    device: false,
    location: true,
    movement: false,
    corporate: false,
    classification: true
  };

  constructor(private fb: FormBuilder, private alarmsService: AlarmsService, private helpService: HelpService) {
    this.classificationForm = this.fb.group({
      status: ['', Validators.required],
      observations: ['']
    });
  }

  showHelp(): void {
    this.helpService.startTour(this.helpService.getAlarmDetailsHelpSteps());
  }

  showHelpLotes(): void {
    this.helpService.startTour(this.helpService.getAlarmClasificHelpSteps());
  }

  ngOnChanges(): void {
    if (this.selectedAlarm()) {
      this.isClassificationEnabled.set(false);
      this.resetFilters();
      this.resetForm();
    }
  }

  toggleClassification(checked: boolean): void {
    this.resetFilters();
    this.isClassificationEnabled.set(checked);
    if (checked) {
      const assetIdToFilter = this.selectedAlarm().gpsReport.assetId;

      this.selectedEvent = this.selectedAlarm().gpsReport.eventId;
      this.currentPage = 0;
      this.hasMorePages.set(true);
      this.selectedHolder = assetIdToFilter;
      this.loadAlarmsHolder(assetIdToFilter, false, this.selectedEvent);
      // actualizar vistas locales después de carga (loadAlarmsHolder hará extractFilterOptions)
      this.filteredAlarms.set([...this.alarms()]);
    } else {
      this.resetFilters();
      this.resetForm();
    }
  }

  extractFilterOptions(): void {
    // Extraer holders únicos
    this.holders = Array.from(new Set(this.alarmsFromChild()
      .map(alarm => alarm.gpsReport?.assetId)
      .filter(holder => holder && holder.trim() !== '')))
      .sort() as string[];

    // Extraer eventos únicos
    this.events = Array.from(new Set(this.alarmsFromChild()
      .map(alarm => alarm.gpsReport?.eventName)
      .filter(event => event && event.trim() !== '')))
      .sort() as string[];
  }

  applyFilters(): void {
    // Vaciar resultados previos
    this.filteredAlarms.set([]);

    // Si se seleccionó un holder, recargar alarmas desde el servidor
    if (this.selectedHolder) {
      this.currentPage = 0;
      this.hasMorePages.set(true);


      this.loadAlarmsHolder(this.selectedHolder, false, this.selectedEvent);
      return;
    }

    this.filteredAlarms.set(this.alarms().filter(alarm => {
      // Filtro por holder
      const matchesHolder = !this.selectedHolder ||
        alarm.gpsReport?.assetId === this.selectedHolder;



      // Filtro por evento
      const matchesEvent = !this.selectedEvent ||
        alarm.gpsReport?.eventName === this.selectedEvent;

      // Filtro por búsqueda
      const matchesSearch = !this.searchTerm ||
        alarm.id?.toString().includes(this.searchTerm) ||
        alarm.gpsReport?.assetId?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        alarm.gpsReport?.eventName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        alarm.gpsReport?.location?.toLowerCase().includes(this.searchTerm.toLowerCase());

      return matchesHolder && matchesEvent && matchesSearch;
    }));
  }

  resetFilters(): void {
    this.selectedHolder = '';
    this.selectedEvent = '';
    this.searchTerm = '';
    this.selectedAlarms.clear();
    this.filteredAlarms.set([...this.alarmsFromChild()]);
  }

  resetForm(): void {
    this.classificationForm.reset();
    this.successMessage.set('');
    this.errorMessage.set('');
  }

  toggleAllAlarms(checked: boolean): void {
    if (checked) {
      this.filteredAlarms().forEach(alarm => {
        if (alarm.id) {
          this.selectedAlarms.add(alarm.id.toString());
        }
      });
    } else {
      this.selectedAlarms.clear();
    }
  }

  toggleAlarmSelection(alarmId: string, checked: boolean): void {
    if (checked) {
      this.selectedAlarms.add(alarmId);
    } else {
      this.selectedAlarms.delete(alarmId);
    }


  }

  isAllSelected(): boolean {
    return this.filteredAlarms().length > 0 &&
      this.filteredAlarms().every(alarm =>
        alarm.id && this.selectedAlarms.has(alarm.id.toString()));
  }

  isSomeSelected(): boolean {
    return this.filteredAlarms().some(alarm =>
      alarm.id && this.selectedAlarms.has(alarm.id.toString())) &&
      !this.isAllSelected();
  }

  getSelectedCount(): number {
    return this.selectedAlarms.size;
  }

  loadAlarmsHolder(assetId: string, append: boolean = false, eventIdToFilter?: string): void {



    if (!this.monitorId()) return;
    if (append && (this.isLoadingMore() || !this.hasMorePages())) return;

    this.isLoadingMore.set(true);
    const page = append ? this.currentPage + 1 : 0;




    const filters: any = { assetId, eventId: eventIdToFilter };
    this.alarmsService.getAlarms(this.monitorId() ?? undefined, page, this.pageSize, filters).subscribe({
      next: (response: AlarmsResponse) => {

        const newAlarms = response.content || [];
        if (append) {
          this.alarms.update(items => [...items, ...newAlarms]);
        } else {
          this.alarms.set(newAlarms);
        }
        this.currentPage = page;
        this.hasMorePages.set(!response.last);
        this.filteredAlarms.set([...this.alarms()]);
        this.extractFilterOptions();
        this.isLoadingMore.set(false);
      },
      error: (_err: any) => {
        this.errorMessage.set('Error al cargar las alarmas del holder');
        this.isLoadingMore.set(false);
      }
    });
  }

  onScrollAlarms(event: Event): void {


    const el = event.target as HTMLElement;
    const threshold = 50;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
      const holderId = this.selectedHolder;
      if (holderId) {
        this.loadAlarmsHolder(holderId, true, this.selectedEvent);
      }
    }
  }


  onSubmit(): void {
    if (this.classificationForm.valid) {
      const formData = this.classificationForm.value;

      // Obtener las alarmas seleccionadas
      const selectedAlarmIds = Array.from(this.selectedAlarms);

      // Obtener información detallada de las alarmas seleccionadas
      const selectedAlarmsDetails = this.filteredAlarms().filter(alarm =>
        alarm.id && this.selectedAlarms.has(alarm.id.toString())
      );




      if (selectedAlarmIds.length > 0) {

        const classificationData = {
          alarmIds: selectedAlarmIds,
          status: this.classificationForm.get('status')?.value,
          observations: this.classificationForm.get('observations')?.value || ''
        };


        this.alarmsService.doBulkClassification(classificationData, this.monitorId()!).subscribe({
          next: (response: any) => {
            this.successMessage.set(`Clasificación aplicada a ${selectedAlarmIds.length} alarmas correctamente`);
            this.errorMessage.set('');

          },
          error: (error) => {
            this.errorMessage.set('Error al clasificar las alarmas');
            this.successMessage.set('');

          },
        });

      } else {
      }



      // Simular envío exitoso
      this.successMessage.set(`Clasificación aplicada a ${selectedAlarmIds.length} alarmas correctamente`);
      this.errorMessage.set('');

      // Limpiar selección después de enviar (opcional)
      setTimeout(() => {
        this.selectedAlarms.clear();
        this.classificationForm.reset();
        this.successMessage.set('');
      }, 3000);


      this.closeDetails();

    } else {
      this.errorMessage.set('Por favor, complete todos los campos requeridos');
      this.successMessage.set('');

      // Mostrar qué campos son inválidos (sin logging en consola)
      Object.keys(this.classificationForm.controls).forEach(key => {
        const control = this.classificationForm.get(key);
        if (control?.invalid) {
          // placeholder for potential UI feedback
        }
      });
    }
  }
  onCancel(): void {
    this.classificationForm.reset();
    this.successMessage.set('');
    this.errorMessage.set('');
  }

  toggleSection(section: string): void {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  isSectionExpanded(section: string): boolean {
    return this.expandedSections[section];
  }

  openMap(): void {
    if (this.selectedAlarm()?.gpsReport?.latitude && this.selectedAlarm()?.gpsReport?.longitude) {
      const lat = this.selectedAlarm().gpsReport.latitude;
      const lng = this.selectedAlarm().gpsReport.longitude;
      window.open(`https://maps.google.com/?q=${lat},${lng}`, '_blank');
    }
  }

  exportData(): void {

  }

  closeDetails(): void {
    this.closed.emit();
  }

  onClassificationSubmit(data: any): void {

  }

  handleClassificationComplete(data: { id: string, status: string }): void {

    this.closeDetails();

  }
}
